import script from "./ConciliacaoChargebackDetalheModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConciliacaoChargebackDetalheModal.vue?vue&type=script&setup=true&lang=js"

import "./ConciliacaoChargebackDetalheModal.vue?vue&type=style&index=0&id=3d5820aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5820aa"]])

export default __exports__